module.exports = __webpack_public_path__ + "media/Loops Strings.6cf1a9a4.wav";